import type { FunctionComponent } from 'react'
import React from 'react'
import { ButtonWrapper, CustomButton } from './CustomButtons.styles'

interface CustomButtonsProps {
  handleSubmit: () => void
  selectedName: string
  handleOpenModal: () => void
}

const CustomButtons: FunctionComponent<CustomButtonsProps> = ({
  handleSubmit,
  selectedName,
  handleOpenModal
}) => {
  return (
    <ButtonWrapper>
      <CustomButton
        primary
        large
        onClick={handleSubmit}
        disabled={!selectedName}
      >
        Avançar
      </CustomButton>
      <CustomButton ghost large onClick={handleOpenModal}>
        Não encontro o estudante
      </CustomButton>
    </ButtonWrapper>
  )
}

export default CustomButtons
